/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-apple': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" d="M6.444 3.685a10 10 0 1111.112 16.63A10 10 0 016.444 3.685zM17.58 8.797l.037-.024c-.994-1.352-2.503-1.389-2.923-1.389-.643 0-1.218.217-1.702.399-.35.131-.652.245-.897.245-.27 0-.58-.119-.925-.251-.436-.167-.93-.356-1.473-.356C7.863 7.42 6 8.864 6 11.586c0 1.697.688 3.485 1.54 4.636.736.98 1.376 1.778 2.292 1.778.435 0 .754-.128 1.09-.264.37-.15.763-.307 1.356-.307.6 0 .957.148 1.303.291.32.133.631.262 1.114.262 1.003 0 1.662-.861 2.292-1.724.708-.98 1.004-1.942 1.013-1.987-.058-.018-1.978-.753-1.978-2.83 0-1.674 1.31-2.49 1.558-2.644zM14.95 4.28c0 .717-.324 1.434-.782 1.95-.487.573-1.329 1-1.998 1-.076 0-.153-.01-.2-.02a1.22 1.22 0 01-.028-.253c0-.726.392-1.443.812-1.897.535-.59 1.422-1.034 2.168-1.061.02.081.028.182.028.281z" _fill="#010005"/>'
  }
})
